import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import ProductCard from "../RudrakshaSection/ProductCard";
import Loader from "../Loader/Loader";
import { getProducts } from "../../api/productApi";
import { getCategories } from "../../api/getCategories";
import API_BASE_URL from "../../config";
const TULSI_CATEGORY_SLUG = "tulsi";
const banners = [
  "https://res.cloudinary.com/yi3u1mel/image/upload/v1793374239/1000457617.png",
  "https://res.cloudinary.com/yi3u1mel/image/upload/v1793374242/1000457616.png",
  "https://res.cloudinary.com/yi3u1mel/image/upload/v1793374234/1000457615.png",
];

export default function TulsiSection() {
  const [tulsiCategory, setTulsiCategory] = useState(null);

  const [subcategories, setSubcategories] = useState([]);

  const [activeSubcategory, setActiveSubcategory] = useState(null);

  const [products, setProducts] = useState([]);

  const [loadingCategories, setLoadingCategories] = useState(true);

  const [loadingProducts, setLoadingProducts] = useState(false);


  useEffect(() => {
    const fetchTulsiCategory = async () => {
      try {
        setLoadingCategories(true);

        const result = await getCategories();

        console.log("All Categories:", result);

        if (!result?.success) {
          setTulsiCategory(null);
          setSubcategories([]);
          return;
        }

        const categories = result?.data || [];

        // Find Tulsi category by slug
        const tulsi = categories.find(
          (category) =>
            category?.slug?.toLowerCase() ===
            TULSI_CATEGORY_SLUG.toLowerCase()
        );

        console.log("Tulsi Category:", tulsi);

        if (!tulsi) {
          console.error("Tulsi category not found");

          setTulsiCategory(null);
          setSubcategories([]);

          return;
        }

        setTulsiCategory(tulsi);

        // If API already sends subcategories
        if (Array.isArray(tulsi.subcategories)) {
          setSubcategories(tulsi.subcategories);
        } else {
          // Otherwise fetch separately
          const subResponse = await fetch(
            `${API_BASE_URL}/categories/${tulsi.id}/subcategories`
          );

          const subResult = await subResponse.json();

          console.log("Tulsi Subcategories:", subResult);

          if (subResult?.success) {
            setSubcategories(subResult.data || []);
          } else {
            setSubcategories([]);
          }
        }
      } catch (error) {
        console.error("Tulsi Category API Error:", error);

        setTulsiCategory(null);
        setSubcategories([]);
      } finally {
        setLoadingCategories(false);
      }
    };

    fetchTulsiCategory();
  }, []);


  const fetchAllProducts = async (categoryId) => {
    try {
      if (!categoryId) return;

      setLoadingProducts(true);

      const result = await getProducts({
        categoryId: categoryId,
        page: 1,
        limit: 12,
      });

      console.log("All Tulsi Products:", result);

      if (result?.success) {
        setProducts(result?.data?.products || []);
      } else {
        setProducts([]);
      }
    } catch (error) {
      console.error("Tulsi Products API Error:", error);

      setProducts([]);
    } finally {
      setLoadingProducts(false);
    }
  };

  const fetchProductsBySubcategory = async (subcategoryId) => {
    try {
      if (!tulsiCategory?.id || !subcategoryId) return;

      setLoadingProducts(true);

      const result = await getProducts({
        categoryId: tulsiCategory.id,
        subcategoryId: subcategoryId,
        page: 1,
        limit: 12,
      });

      console.log("Tulsi Products By Subcategory:", result);

      if (result?.success) {
        setProducts(result?.data?.products || []);
      } else {
        setProducts([]);
      }
    } catch (error) {
      console.error(
        "Tulsi Subcategory Products API Error:",
        error
      );

      setProducts([]);
    } finally {
      setLoadingProducts(false);
    }
  };


  useEffect(() => {
    if (tulsiCategory?.id) {
      setActiveSubcategory(null);

      fetchAllProducts(tulsiCategory.id);
    }
  }, [tulsiCategory]);


  const handleSubcategoryClick = (subcategory) => {
    if (!subcategory?.id) return;

    setActiveSubcategory(subcategory.id);

    fetchProductsBySubcategory(subcategory.id);
  };


  const handleAllClick = () => {
    if (!tulsiCategory?.id) return;

    setActiveSubcategory(null);

    fetchAllProducts(tulsiCategory.id);
  };



  return (
    <section className="rudraksha-section">
      <div className="container">

      

        <div className="section-top">

          <h2>
            Buy Premium Tulsi, Chandan & Other Wood Products
          </h2>

       

          <div className="tabs">

            {/* ALL TULSI */}

            <button
              type="button"
              className={
                activeSubcategory === null
                  ? "active"
                  : ""
              }
              onClick={handleAllClick}
              disabled={loadingCategories || !tulsiCategory}
            >
              All Tulsi Products
            </button>

            {/* API SUBCATEGORIES */}

            {!loadingCategories &&
              subcategories.map((subcategory) => (
                <button
                  type="button"
                  key={subcategory.id}
                  className={
                    activeSubcategory === subcategory.id
                      ? "active"
                      : ""
                  }
                  onClick={() =>
                    handleSubcategoryClick(subcategory)
                  }
                >
                  {subcategory.name}
                </button>
              ))}

          </div>
        </div>


        <div className="section-content">

       

          <div className="left-banner">

            <Swiper
              modules={[Autoplay]}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              loop
            >
              {banners.map((image, index) => (
                <SwiperSlide key={index}>
                  <img
                    src={image}
                    alt="Tulsi, Chandan & Wood Products"
                  />
                </SwiperSlide>
              ))}
            </Swiper>

          </div>

    
          <div className="right-products">

            {/* LOADING */}

            {loadingCategories || loadingProducts ? (
              <div className="loading">
                <Loader label="Loading Tulsi products..." size={56} />
              </div>
            ) : products.length === 0 ? (
              /* NO PRODUCTS */

              <div className="loading">
                No Tulsi products found
              </div>
            ) : (
              <Swiper
                modules={[
                  Navigation,
                  Autoplay,
                ]}
                navigation
                loop={products.length > 3}
                spaceBetween={10}
                slidesPerView={3}
                breakpoints={{
                  0: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },

                  576: {
                    slidesPerView: 2,
                    spaceBetween: 12,
                  },

                  768: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                  },

                  1200: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },
                }}
              >
                {products.map((product) => (
                  <SwiperSlide key={product.id}>
                    <ProductCard product={product} />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}

          </div>
        </div>
      </div>
    </section>
  );
}